






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'
import {InputMotoristaResponsavelSchema} from '@/schema/resource/MotoristaResponsavel/InputMotoristaResponsavelSchema'

@Component
export default class PersistMotoristaResponsavelView extends Vue {
  @Prop() id1?: string
  @Prop() id2?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMotoristaResponsavelSchema()
  motoristaResponsavel = new MotoristaResponsavel()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionMotorista.listMotorista()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id1 = Number(this.id1) || null
    const id2 = Number(this.id2) || null

    if (id1 && id2) {
      await this.motoristaResponsavel.getMotoristaResponsavel(id1, id2)
    }

    $.await.done('getMotoristaResponsavel')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.motoristaResponsavel.persistMotoristaResponsavel()
    await Helper.successAndPush(
      'system.success.persist',
      '/motorista-responsavel/list'
    )
  }
}
